import FormDisplay from "pages/FormDisplay";
import ConditionalRendering from "pages/ConditionalRendering";
import AccountList from "pages/AccountList";
import WorkflowVerification from "pages/WorkflowVerification";
// DASHBOARD PAGES
import ForgotPassword from "pages/DashBoard/LoginPage/ForgotPassword";
import SignIn from "pages/DashBoard/LoginPage/SignIn";
import SetPassword from "pages/DashBoard/LoginPage/SetPassword";
import { ROUTES } from "constants/routes";
import Consents from "pages/Consents";
import ClientDetailDashBoard from "pages/ClientDetailDashBoard";
import HomePage from "pages/DashBoard/HomePage";
import DashboardForms from "pages/DashBoard/DashboardForms";
import DetailViewDashboard from "pages/DetailViewDashboard";
import SuccessPage from "pages/SuccessPage";
import StatusLoader from "pages/StatusLoader";
import SupportingDocuments from "pages/SupportingDocuments";
import RouteComponent from "pages/RouteComponent";
import ErrorPage from "pages/ErrorPage";
import Payment from "pages/Payment";
import PaymentConfirmation from "pages/PaymentConfirmation";
import PaymentSucess from "pages/PaymentSuccess";
import StatusTracking from "pages/StatusTracking";
import BulkWorkflow from "pages/BulkWorkflow";
export const PUBLIC_ROUTES = [

  {
    path: ROUTES.CONDTIONAL_RENDERING,
    component: ConditionalRendering,
    title: "condtinal",
    decrypt: true
  },
  {
    path: ROUTES.ACCOUNT_DETAILS,
    component: AccountList,
    title: "Accountlist",
  },
  {
    path: ROUTES.DASHBOARD_LISTING,
    component: HomePage,
    title: "Dashboard",
    isPrivate: true
  },
  {
    path: ROUTES.DASHBOARD_LOGIN,
    component: SignIn,
    title: "SignIn",
  },
  {
    path: ROUTES.FORGET_PASSWORD,
    component: ForgotPassword,
    title: "ForgetPassword",
  },
  {
    path: ROUTES.RESET_PASSWORD,
    component: SetPassword,
    title: "setPassword",
  },
  {
    path: ROUTES.FORM_DISPLAY,
    component: FormDisplay,
    title: "FormDisplay",
    decrypt: true
  },
  {
    path: ROUTES.DYNAMIC_FORMS,
    component: FormDisplay,
    title: "FormDisplay",
    decrypt: true
  },
  {
    path: ROUTES.UPDATE_CONDITIONAL_REDIRECTION,
    component : WorkflowVerification,
    title: "UpdateData",
    decrypt: true
  }, 
  {
    path: ROUTES.UPDATE_DYNAMIC_REDIRECTION,
    component: FormDisplay,
    title: "UpdateData",
    decrypt: true
  },
  {
    path: ROUTES.CONSENTS,
    component: Consents,
    title: "Consents",
  },
  {
    path: ROUTES.CLIENT_DETAIL,
    component: ClientDetailDashBoard,
    title: "Dashboard",
  },
  {
    path: ROUTES.DASHBOARD_FORMS,
    component: DashboardForms,
    title: "DashboardForm",
  },
  {
    path: ROUTES.CLIENT_DETAIL_DASHBOARD,
    component: DetailViewDashboard,
    title: "Dashboard",
    isPrivate: true
  },
  {
    path: ROUTES.UPDATE_SUCCESSFUL,
    component: SuccessPage,
    title: "SuccessPage"
  },
  {
    path: ROUTES.APPLICANTION_SUBMITTED_SUCCESSFULLY,
    component: SuccessPage,
    title: "Applicant SuccessPage",
  },
  {
    path: ROUTES.USER_APPLICANTION_SUBMITTED_SUCCESSFULLY,
    component: SuccessPage,
    title: "Applicant SuccessPage status",
    decrypt: true
  },
  {
    path: ROUTES.SUPPORTING_DOCUMENTS,
    component: SupportingDocuments,
    title: "SupportingDocuments",
    decrypt: true

  },
  {
    path: ROUTES.SUCCESS_LOADER,
    component: StatusLoader,
    title: "SuccessPage",
  },
  {
    path: ROUTES.ROUTE_HOME,
    component: RouteComponent,
    title: "HomeRoute",
  },
  {
    path: ROUTES.ERROR,
    component: ErrorPage,
    title: "Error",
  },
  {
    path: ROUTES.PAYMENT,
    component: Payment,
    title: "Payment",
    decrypt: true
  },
  {
    path: ROUTES.PAYMENT_CONFIRMATION,
    component: PaymentConfirmation,
    title: "Payment Confirmation",
    decrypt: true,
  },
  {
    path: ROUTES.PAYMENT_SUCCESS,
    component: PaymentSucess,
    title: "Payment Success",
    decrypt: true,
  },
  {
    path: ROUTES.APPLICATION_STATUS_TRACKING,
    component: StatusTracking,
    title: "Application Status Tracking",
    decrypt: true,
  },
  {
    path: "/*",
    component: ErrorPage,
    title: "Error",
  },
  {
    path: ROUTES.BULK_WORKFLOW_CREATION,
    component: BulkWorkflow,
    title: "BulkWorkflow",
    decrypt: true,
  },
];